// Copyright (c) StrangeBee 2023

import { AnalysisQuickview } from '@Organisms/AnalysisData/AnalysisQuickview';
import { useGenericQuery } from '@Queries/genericQueries';
import React, { ReactElement } from 'react';
import { ObservableEventList } from '@Organisms/Observable/eventList';
import DisplayTag from '@Organisms/DisplayTag/DisplayTag';
import { ObservableOutput } from 'thehive-sdk';

interface ObservableReportTagProps {
    analyzerId: string;
    observableId: string;
    onGetLastReport: ObservableEventList['onGetLastReport'];
    value: string;
    color: string;
    eventList?: ObservableEventList;
    hasPermissions?: boolean;
    observable?: ObservableOutput;
    importObservable?: boolean;
}

export const ObservableReportTag = ({
    analyzerId,
    observableId,
    observable,
    value,
    color,
    onGetLastReport,
    hasPermissions = false,
    eventList,
    importObservable = false,
}: ObservableReportTagProps): ReactElement => {
    const { data: analysisData, refetch } = useGenericQuery({
        manual: true,
        fetchOnStart: false,
        fetchCallback: () => onGetLastReport(analyzerId, observableId),
        key: ['get-observable-report', analyzerId],
    });

    const onDrawerOpen = (): void => {
        refetch();
    };

    return (
        <AnalysisQuickview
            data={analysisData}
            hasPermissions={hasPermissions}
            observable={observable}
            importObservable={importObservable}
            eventList={eventList}
            triggerElem={<DisplayTag color={color} tag={value} full />}
            onDrawerOpen={onDrawerOpen}
        />
    );
};
